const RPC_MERCHANT_SERVICE_ENDPOINT = "/services/squareup.roster.frontend.external.MerchantService";
export {
  RPC_MERCHANT_SERVICE_ENDPOINT
};
//# sourceMappingURL=constants.js.map
